var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 64,
    height: 64,
    transform: "translate(0.234 0.234)",
    stroke: "#fff",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731",
    transform: "translate(-0.234 -0.234)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M37.937,67.374h0A29.437,29.437,0,0,1,8.5,37.937h0a29.437,29.437,0,0,1,58.873,0h0A29.437,29.437,0,0,1,37.937,67.374Z",
    transform: "translate(-5.703 -5.703)",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    x2: 21.062,
    y2: 21.062,
    transform: "translate(21.703 21.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    x1: 21.062,
    y2: 21.062,
    transform: "translate(21.703 21.703)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8f15e7d80d7f75af30b95abe5a9d4fac.svg";
export { ForwardRef as ReactComponent };